// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
// import ScrollSmooth from './modules/Animation/scrollLenis'
// import AnchorLinks from './modules/Utils/anchor_links'
import AnimationElements  from './modules/Animation/enterElements'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import forms from './modules/Forms/forms'
import Preloader from './modules/Utils/preloader'

// Utils
Preloader()
// AnchorLinks()

// LAYOUTS
import Menu from './modules/Layouts/menu'

//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
//forms
forms();

// Animations
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()
// ScrollSmooth()

// Layout
Menu()